import * as css from './editor.css';
export default css;
